import { LineItem } from '@app/domain/LineItem'

export class Order {
    constructor(
        public id: string,
        public venueId: string,
        public lineItems: LineItem[],
        public currencyCode: string,
        public message: string | null,
        public dateCreated: Date,
        public dateUpdated: Date,
        public isPaid: boolean = false
    ) { }

    total(): number {
        return this.lineItems.reduce((total, item) => total + item.unitAmount() * item.quantity, 0)
    }
}
